import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import MapIcon from '@mui/icons-material/Map';
import { Checkbox, FormControlLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import { setTodaysDate } from '../actions/today';
var Filter = function Filter(props) {
  var _props$locations, _props$locations2, _props$eventTypes, _props$eventTypes2;
  var selectedFilters = props.selectedFilters;
  var events = useSelector(function (state) {
    return state.events;
  });
  var mapToggled = useSelector(function (state) {
    return state.mapToggled;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    eventCatsFiltered = _useState2[0],
    setEventCatsFiltered = _useState2[1];
  var dispatch = useDispatch();
  var navigate = useNavigate();
  var params = useParams();
  var filterRef = useRef();
  useEffect(function () {
    if (!props.showed) return;
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        // ✅ Clicked outside #events-filter — call your function
        props.onHide();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [props.showed]);
  useEffect(function () {
    setInterval(function () {
      return dispatch(setTodaysDate(new Date()));
    }, 60000);
  }, []);
  var hasClearFilter = useMemo(function () {
    return selectedFilters.date.length > 0 || selectedFilters.location.length > 0 || selectedFilters.types.length > 0;
  }, [selectedFilters]);
  var handleClearFilters = function handleClearFilters() {
    props.onClear(selectedFilters.option);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "events-filter",
    ref: filterRef,
    className: "".concat(props.showed ? 'mobile-showed' : ''),
    style: {
      padding: 20,
      borderRight: '5px solid #333'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-close",
    onClick: function onClick() {
      return props.onHide();
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    sx: {
      fontSize: 12,
      borderRadius: '50%',
      backgroundColor: '#DDD',
      color: '#000'
    }
  }), /*#__PURE__*/React.createElement("span", null, "Close")), /*#__PURE__*/React.createElement("div", {
    className: "category-selector",
    style: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    sx: {
      flex: 1,
      color: (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.option) === 'in-person' ? '#FFF' : '#000',
      fontSize: '1.2rem',
      fontFamily: 'Bebas Neue',
      background: (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.option) === 'in-person' ? '#000' : 'transparent',
      boxShadow: 'none',
      border: '2px solid #000',
      borderTopRightRadius: '0',
      borderBottomRightRadius: '0',
      '&:hover, &.Mui-focusVisible': {
        background: '#777',
        borderColor: '#777',
        boxShadow: 'none'
      },
      '&:focus': {
        borderColor: '#000'
      }
    },
    onClick: function onClick() {
      return props === null || props === void 0 ? void 0 : props.onSelectFilter('option', 'in-person');
    }
  }, "In-Person"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    sx: {
      flex: 1,
      color: (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.option) === 'virtual' ? '#FFF' : '#000',
      fontSize: '1.2rem',
      fontFamily: 'Bebas Neue',
      background: (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.option) === 'virtual' ? '#000' : 'transparent',
      boxShadow: 'none',
      border: '2px solid #000',
      borderLeft: 'none',
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
      '&:hover, &.Mui-focusVisible': {
        background: '#777',
        borderColor: '#777',
        boxShadow: 'none'
      },
      '&:focus': {
        borderColor: '#000'
      }
    },
    onClick: function onClick() {
      return props === null || props === void 0 ? void 0 : props.onSelectFilter('option', 'virtual');
    }
  }, "Virtual")), hasClearFilter && /*#__PURE__*/React.createElement("div", {
    className: "clear-filter",
    onClick: handleClearFilters
  }, "Clear filters"), /*#__PURE__*/React.createElement("div", {
    className: "event-day-filter"
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "Event Days"), /*#__PURE__*/React.createElement("div", {
    id: "events-header-tabs",
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, eventIntros.length > 1 && eventIntros.map(function (day) {
    var _Date;
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: day,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          var _selectedFilters$date;
          if ((selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$date = selectedFilters.date) === null || _selectedFilters$date === void 0 ? void 0 : _selectedFilters$date.indexOf(day)) > -1) {
            var _selectedFilters$date2;
            var dates = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.date;
            dates === null || dates === void 0 || dates.splice(selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$date2 = selectedFilters.date) === null || _selectedFilters$date2 === void 0 ? void 0 : _selectedFilters$date2.indexOf(day), 1);
            props === null || props === void 0 || props.onSelectFilter('date', dates);
          } else {
            props === null || props === void 0 || props.onSelectFilter('date', [].concat(_toConsumableArray(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.date), [day]));
          }
        },
        sx: {
          padding: "0 .5rem 0 0",
          "&.Mui-checked": {
            color: "#000"
          }
        },
        checked: selectedFilters.date.includes(day)
      }),
      label: "".concat(new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        timeZone: 'UTC'
      }).format(new Date(day)), ", ").concat(new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: '2-digit',
        timeZone: 'UTC'
      }).format(new Date(day)), ", ").concat((_Date = new Date(day)) === null || _Date === void 0 ? void 0 : _Date.getFullYear())
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "event-location-filter"
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "Location"), /*#__PURE__*/React.createElement("div", {
    className: "location-wrapper",
    style: {
      paddingLeft: 8,
      paddingRight: 8,
      display: 'flex',
      flexDirection: 'column'
    }
  }, (props === null || props === void 0 || (_props$locations = props.locations) === null || _props$locations === void 0 ? void 0 : _props$locations.length) > 0 && (props === null || props === void 0 || (_props$locations2 = props.locations) === null || _props$locations2 === void 0 ? void 0 : _props$locations2.map(function (location, index) {
    if (!location.label) return /*#__PURE__*/React.createElement(React.Fragment, null);
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: "date-".concat(index),
      control: /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          var _selectedFilters$loca;
          if ((selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$loca = selectedFilters.location) === null || _selectedFilters$loca === void 0 ? void 0 : _selectedFilters$loca.indexOf(location)) > -1) {
            var _selectedFilters$loca2;
            var locations = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.location;
            locations === null || locations === void 0 || locations.splice(selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$loca2 = selectedFilters.location) === null || _selectedFilters$loca2 === void 0 ? void 0 : _selectedFilters$loca2.indexOf(location), 1);
            props === null || props === void 0 || props.onSelectFilter('location', locations);
          } else {
            props === null || props === void 0 || props.onSelectFilter('location', [].concat(_toConsumableArray(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.location), [location]));
          }
        },
        sx: {
          padding: "0 .5rem 0 0",
          "&.Mui-checked": {
            color: "#000"
          }
        },
        checked: selectedFilters.location.includes(location)
      }),
      label: location.label
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "event-types-filter"
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginBottom: 10
    }
  }, "Types"), /*#__PURE__*/React.createElement("div", {
    className: "types-wrapper",
    style: {
      paddingLeft: 8,
      paddingRight: 8,
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)'
    }
  }, (props === null || props === void 0 || (_props$eventTypes = props.eventTypes) === null || _props$eventTypes === void 0 ? void 0 : _props$eventTypes.length) > 0 && (props === null || props === void 0 || (_props$eventTypes2 = props.eventTypes) === null || _props$eventTypes2 === void 0 ? void 0 : _props$eventTypes2.map(function (type, index) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: "date-".concat(index),
      control: /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange() {
          var _selectedFilters$type;
          if ((selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$type = selectedFilters.types) === null || _selectedFilters$type === void 0 ? void 0 : _selectedFilters$type.indexOf(type === null || type === void 0 ? void 0 : type.slug)) > -1) {
            var _selectedFilters$type2;
            var types = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.types;
            types === null || types === void 0 || types.splice(selectedFilters === null || selectedFilters === void 0 || (_selectedFilters$type2 = selectedFilters.types) === null || _selectedFilters$type2 === void 0 ? void 0 : _selectedFilters$type2.indexOf(type === null || type === void 0 ? void 0 : type.slug), 1);
            props === null || props === void 0 || props.onSelectFilter('types', types);
          } else {
            props === null || props === void 0 || props.onSelectFilter('types', [].concat(_toConsumableArray(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.types), [type === null || type === void 0 ? void 0 : type.slug]));
          }
        },
        sx: {
          padding: "0 .5rem 0 0",
          "&.Mui-checked": {
            color: "#000"
          }
        },
        checked: selectedFilters.types.includes(type === null || type === void 0 ? void 0 : type.slug)
      }),
      label: type === null || type === void 0 ? void 0 : type.name
    });
  })))));
};
Filter.propTypes = {};
export default Filter;